module.exports = __webpack_public_path__ + "static/media/case2.a4cb53d9.png";